import React, { Component } from 'react';
import { Button, Divider, Form, Grid, Header, Input, Segment } from 'semantic-ui-react';
import { toast, ToastContainer } from 'react-toastify';
import axios from 'axios';
import moment from 'moment';

const fetchStudentGrade = () => axios.get(`/student-exams/grades-for-cancellation/${JSON.parse(localStorage.getItem('student')).id}`);
class CancelGrade extends Component {
    constructor(props, context) {
        super(props, context);
        this.state = {
            // documentNumber: null,
            grade: null,
        };
        this.handleInputChange = this.handleInputChange.bind(this);
        this.fetchAll = this.fetchAll.bind(this);
        this.resetForm = this.resetForm.bind(this);
        this.cancelGrade = this.cancelGrade.bind(this);
    }

    componentWillMount() {
        this.fetchAll();
    }

    fetchAll() {
        axios.all([fetchStudentGrade()])
            .then(axios.spread((studentGradeRes) => {
                const studentGrade = studentGradeRes.data.map(el => ({
                    ...el,
                    text: el.courseBasicName + ' | ' + el.markDisplayName,
                    // text: 'test',
                    value: {
                        markId: el.studentMarkId, optLock: el.optLock, studentCourseImplementationId: el.studentCourseImplementationId, courseImplementationId: el.courseImplementationId
                    },
                    key: el.studentMarkId
                })).filter((e) => e.markDisplayName !== 'nije ocijenjen/nije pristupio');
                this.setState({
                    studentGrade,
                    loading: false
                });
            }))
            .catch(err => {
                this.setState({ error: true });
                console.log('Failed to fetch data...');
            });
    }

    resetForm() {
        this.setState({
            grade: null,
            // documentNumber: '',
            // documentNumberErr: false,
            gradeErr: false,
        });
    }

    cancelGrade() {
        const { grade, documentNumber } = this.state;
        this.setState({ loading: true });
        if (!grade
        // || !documentNumber
        ) {
            toast('Niste unijeli sva obavezna polja!');
            // if (!documentNumber) { this.setState({ documentNumberErr: true }); } else { this.setState({ documentNumberErr: false }); }
            if (!grade) { this.setState({ gradeErr: true }); } else { this.setState({ gradeErr: false }); }
        } else {
            let obj = {
                id: grade.markId,
                optLock: grade.optLock,
                comment: 'Ocjena poništena ' + moment(new Date(moment.now())).format('DD. MM. YYYY.').toString()
                // documentNumber: this.state.documentNumber,
            };
            axios.put('/student-exams/cancel-mark/', { ...obj })
                .then(res => {
                    this.setState({ loading: false });
                    toast('Ocjena je poništena.');
                    this.resetForm();
                    this.fetchAll();
                })
                .catch(err => {
                    toast('Došlo je do greške! Ocjena nije poništena.');
                });
        }
    }

    handleInputChange(event, { name, value }) {
        this.setState({
            [name]: value
        });
    }

    render() {
        const { loading } = this.state;
        const student = JSON.parse(localStorage.getItem('student'));
        return (
            <div>

                <h1>Poništavanje ocjene</h1>
                <Segment.Group raised>
                    <Segment>
                        <Header
                            as="h3"
                            content={student.firstName + ' ' + student.lastName + ' - ' + student.index}
                            subheader="Student/ica / index"
                        />
                    </Segment>
                    {!student.locked && student.dateOfAbandonment === null && student.studyProgramStudentSwitchedToId === null ?
                        <Segment clearing>
                            <Form noValidate>
                                <Grid stackable>

                                    <Grid.Column>

                                        <Form.Group >
                                            <Form.Field required error={this.state.gradeErr} width={8}>
                                                <Form.Dropdown
                                                    clearable
                                                    selection
                                                    placeholder="Odaberite ocjenu"
                                                    defaultValue={null}
                                                    value={this.state.grade}
                                                    onChange={this.handleInputChange}
                                                    name="grade"
                                                    options={this.state.studentGrade}
                                                    search
                                                    fluid
                                                />
                                            </Form.Field>
                                            <Form.Field width={8}>
                                                <Button
                                                    disabled={loading}
                                                    loading={loading}
                                                    floated="left"
                                                    color="blue"
                                                    onClick={this.cancelGrade}
                                                >
                                                    Potvrdi
                                                </Button>
                                                <Button
                                                    disabled={loading}
                                                    basic
                                                    color="blue"
                                                    floated="left"
                                                    onClick={this.resetForm}
                                                >
                                                    Odustani
                                                </Button>
                                            </Form.Field>
                                        </Form.Group>


                                    </Grid.Column>

                                </Grid>
                            </Form>
                        </Segment> : <Segment><p>Studentu/ici se ne mogu poništavati ocjene.</p></Segment>}
                </Segment.Group>
                <ToastContainer hideProgressBar />
            </div>
        );
    }
}

export default CancelGrade;



// WEBPACK FOOTER //
// ./src/views/StudentService/Exams/CancelGrade.js